import { _ as t } from "./main52.js";
var r = t;
function p(a) {
  return r(this, a).has(a);
}
var e = p;
export {
  e as _
};
